import {Device} from "../../model/device";

export class ForgotPasswordRequest extends Device {
  email: string;

  constructor() {
    super();
  }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/forgot-password/forgot-password-request.ts